'use client';

import { useMemo } from 'react';

import * as styles from './BannerTopsort.css';

const BANNER_SIZES = {
    desktop: { width: 1110, height: 200 },
    mobile: { width: 608, height: 200 },
};

export default function BannerTopsort({
  idBanner,
  isMobile = true,
}: {
  idBanner: string;
  isMobile?: boolean;
}) {
  const deviceType = isMobile ? 'mobile' : 'desktop';
  const size = useMemo(() => (BANNER_SIZES?.[deviceType]), [isMobile]);

  return (
    <div className={styles.ContainerBase}>
      <topsort-banner {...size} id={idBanner} />
    </div>
  );
}
